<template>
  <div class="search-container">
    <div class="input-container">
      <el-input
        :placeholder="$t('crm.onlineCs.enter.content')"
        v-model="inputValue"
        @change="handleChange"
        id="toggleButton"
        class="input-wrap"
        :style="style"
      >
        <i slot="prefix" class="el-input__icon el-icon-search"></i>
        <el-button slot="suffix" type="primary" @click="() => handleChange(inputValue)">
          {{ $t('crm.onlineCs.msg.search') }}
        </el-button>
      </el-input>
      <div class="result-container" id="panel" v-if="show">
        <div v-for="(item, index) in list" :key="index" class="item">
          <div class="title">
            <span class="mark">Q:</span>
            <span v-html="item.title"></span>
          </div>
          <div class="content">
            <span class="mark">A:</span>
            <div class="content-box">
              <div class="inner" v-html="item.content"></div>
              <el-image
                z-index="99999999999"
                :preview-src-list="[item.attachImgs]"
                :src="item.attachImgs"
                v-if="item?.attachImgs"
                style="width: 90px;height: 90px"
              ></el-image>
              <!-- <el-image
                z-index="99999999999"
                :preview-src-list="[
                  'https://prod-qmovepub.obs.tr-west-1.myhuaweicloud.com/static-resource/zh-CN/172e07b0-757c-482d-a19b-f4923aa11f4d.png'
                ]"
                src="https://prod-qmovepub.obs.tr-west-1.myhuaweicloud.com/static-resource/zh-CN/172e07b0-757c-482d-a19b-f4923aa11f4d.png"
              ></el-image> -->
            </div>

            <i
              class="el-icon-document-copy"
              style="margin-top: 6px; cursor: pointer"
              @click="() => copy(item)"
              v-if="item.contentType !== 'link' && item.content"
            ></i>
          </div>
        </div>
        <el-empty :description="$t('crm.onlineCs.data.empty')" v-if="!list?.length"></el-empty>
      </div>
      <div class="mask" id="mask" v-if="show" @click="() => toggle(false)"></div>
    </div>
  </div>
</template>
<script>
import { crmRequest } from '@crmbest/util'

export default {
  data() {
    return {
      show: false,
      inputValue: '',
      list: [],
      style: ''
    }
  },
  mounted() {},
  watch: {
    show(value) {
      if (value) {
        this.style = 'z-index: 9999999999'
      } else {
        this.style = 'z-index: 0'
      }
    }
  },
  methods: {
    handleChange(value) {
      if (value) {
        this.getData()
      }
    },
    toggle(value) {
      this.show = value
      if (!value) {
        this.inputValue = ''
        this.list = []
      }
    },
    copy(data) {
      navigator.clipboard
        .writeText(data.originText)
        .then(() => {
          this.$message({
            type: 'success',
            message: this.$t('crm.onlineCs.copy.success')
          })
          console.log('文本已成功复制到剪贴板:', data.originText)
        })
        .catch(err => {})
      // let url = '<img src="https://prod-qmovepub.obs.tr-west-1.myhuaweicloud.com/static-resource/zh-CN/172e07b0-757c-482d-a19b-f4923aa11f4d.png"></img>'
      // let test = '<div>54985745<img src="https://prod-qmovepub.obs.tr-west-1.myhuaweicloud.com/static-resource/zh-CN/172e07b0-757c-482d-a19b-f4923aa11f4d.png"></img></div>'
      // console.log(999, data)
      // Events.emit(Events.IM_POST_MESSAGE, {
      //   actionType: POST_MESSAGE_ACTION_TYPE.codes.EDIT_MSG,
      //   content: url
      // })
      // this.copyPhoto()
    },
    copyPhoto() {
      const imgUrl =
        'https://prod-qmovepub.obs.tr-west-1.myhuaweicloud.com/static-resource/zh-CN/172e07b0-757c-482d-a19b-f4923aa11f4d.png'
      if (!navigator.clipboard || !window.ClipboardItem) {
        alert('Clipboard API is not supported in this browser.')
        return
      }

      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')

      const img = new Image()
      img.crossOrigin = 'Anonymous' // 确保可以跨域访问
      img.onload = function() {
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)

        canvas.toBlob(blob => {
          if (blob) {
            navigator.clipboard
              .write([new ClipboardItem({ 'image/png': blob })])
              .then(() => {
                alert('Image copied to clipboard!')
              })
              .catch(error => {
                console.error('Clipboard write error: ', error)
                alert('Failed to copy the image.')
              })
          } else {
            alert('Failed to convert canvas to blob.')
          }
        }, 'image/png')
      }

      img.onerror = function() {
        console.error('Image loading error.')
        alert('Failed to load the image. Please check the URL.')
      }

      img.src = imgUrl
    },
    async getData() {
      try {
        const res =
          (await crmRequest('/qmove-crm-admin/knowledge/article/search', {
            method: 'post',
            data: {
              title: this.inputValue
            }
          })) || []
        const reg = new RegExp(this.inputValue, 'ig')
        this.list = res.map(item => {
          item.originText = item.content
          item.title = item.title.replace(reg, `<span style="color: red">${this.inputValue}</span>`)
          if (item.contentType == 'link') {
            item.content = `<a href=${item.content} target="_blank">${item.content}</a>`
          } else {
            item.content = item.content
              ? item.content.replace(reg, `<span style="color: red">${this.inputValue}</span>`)
              : ''
          }

          return item
        })
        this.show = true
      } catch (error) {}
    }
  }
}
</script>
<style lang="stylus" scoped>
/deep/.el-input__suffix{
right: 0
}
.search-container{
  width: 600px;
  .input-container{
    position: relative;
    .input-wrap{
    }
    .mask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
     background: transparent;
      opacity: 0.4;
      z-index: 99999998
    }
    .result-container{
      max-height: 788px;
    overflow: scroll;
      overflow-y: scroll;
      background: #fff;
      position: absolute;
      top: 48px;
      left: 0;
      right: -240px;
      z-index: 99999999;
      padding: 12px;
      box-shadow: -1px -1px 5px 1px #888888;
      .item{
        font-size: 14px;
        margin-bottom: 16px;
        .title,.content{
          display: flex;
          justify-content: flex-start;
          .mark{
            margin-right: 6px
          }
        }
        .title{
          color: #1a1a1a;
          margin-bottom: 12px
        }
        .content{
          color: #666;
          .content-box{
            flex: 1;
            margin-right: 24px;
            .inner{
              white-space: pre-wrap;
            }
          }
        }

      }
    }
  }
}
</style>
